/**
 * SellEasy Cart Integration
 * Handles add to cart functionality for SellEasy products in cart upsell
 */

var SellEasyCart = SellEasyCart || {};

SellEasyCart = {
  isProcessing: false,
  
  buttonSelector: '.selleasy-cart-upsell .lb-button, .selleasy-cart-upsell .lb-button-cont, .selleasy-cart-upsell .lb-button-sm, .selleasy-cart-upsell [class*="lb-button"], .selleasy-cart-upsell .lb-action-product, .selleasy-cart-upsell [class*="lb-action"]',
  

  init: function() {
    this.interceptSellEasyAjax();
    this.initAddToCart();
    this.observeSellEasyWidgets();
  },
  
  interceptSellEasyAjax: function() {
    const self = this;
    
    // Intercept jQuery AJAX
    if (!window._originalJQueryAjax) {
      window._originalJQueryAjax = $.ajax;
      
      $.ajax = function(options) {
        let url = '';
        let headers = null;
        
        if (typeof options === 'string') {
          url = options;
        } else if (options && typeof options === 'object') {
          url = options.url || '';
          headers = options.headers;
        }
        
        if (url && url.indexOf('/cart/add') !== -1) {
          const hasUrlMarker = url.indexOf('_selleasy_custom=') !== -1;
          const hasHeaderMarker = headers && headers['X-SellEasy-Custom'] === 'true';
          const isOurRequest = hasUrlMarker || hasHeaderMarker;
          
          if (!isOurRequest) {
            let isFromSellEasyWidget = false;
            try {
              const activeElement = document.activeElement;
              if (activeElement) {
                const $activeEl = $(activeElement);
                isFromSellEasyWidget = $activeEl.closest('.selleasy-cart-upsell').length > 0 ||
                                      $activeEl.is('.selleasy-cart-upsell') ||
                                      $activeEl.closest('[class*="lb-button"], [class*="lb-action"]').length > 0;
              }
            } catch (e) {
              // If we can't check active element, continue
            }
            
            if (!isFromSellEasyWidget) {
              try {
                const stack = new Error().stack || '';
                isFromSellEasyWidget = stack.indexOf('selleasy') !== -1 || 
                                      stack.indexOf('lb-button') !== -1 ||
                                      stack.indexOf('lb-action') !== -1 ||
                                      stack.indexOf('installHook') !== -1;
              } catch (e) {
                // If we can't check stack, don't block
              }
            }
            
            if (self.isProcessing && isFromSellEasyWidget) {
            //   // console.log('SellEasy: Blocked duplicate add to cart request from SellEasy widget. URL:', url);
              return $.Deferred().reject({
                status: 0,
                statusText: 'Blocked - handled by custom handler',
                responseText: JSON.stringify({description: 'Request blocked to prevent duplicate'})
              });
            }
            // If not from SellEasy widget or not processing, allow it (it's from other add to cart functions)
          } else if (isOurRequest) {
            // // console.log('SellEasy: Allowing our custom add to cart request. URL:', url);
          }
        }
        
        // Call original ajax with original arguments (don't modify)
        return window._originalJQueryAjax.apply(this, arguments);
      };
    }
    
    if (!window._originalFetch && typeof fetch !== 'undefined') {
      window._originalFetch = window.fetch;
      
      window.fetch = function(url, options) {
        if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
          // Check if it's our request (has _selleasy_custom parameter)
          const isOurRequest = url.indexOf('_selleasy_custom=') !== -1 ||
                              (options && options.headers && options.headers['X-SellEasy-Custom'] === 'true');
          
          if (!isOurRequest && self.isProcessing) {
            let isFromSellEasyWidget = false;
            try {
              const activeElement = document.activeElement;
              if (activeElement) {
                const $activeEl = $(activeElement);
                isFromSellEasyWidget = $activeEl.closest('.selleasy-cart-upsell').length > 0 ||
                                      $activeEl.is('.selleasy-cart-upsell') ||
                                      $activeEl.closest('[class*="lb-button"], [class*="lb-action"]').length > 0;
              }
            } catch (e) {}
            
            if (!isFromSellEasyWidget) {
              try {
                const stack = new Error().stack || '';
                isFromSellEasyWidget = stack.indexOf('selleasy') !== -1 || 
                                      stack.indexOf('lb-button') !== -1 ||
                                      stack.indexOf('lb-action') !== -1 ||
                                      stack.indexOf('installHook') !== -1;
              } catch (e) {}
            }
            
            if (isFromSellEasyWidget) {
              // console.log('SellEasy: Blocked fetch add to cart request from SellEasy widget');
              return Promise.reject(new Error('Blocked - handled by custom handler'));
            }
          }
        }
        
        return window._originalFetch.apply(this, arguments);
      };
    }
    
    if (!window._originalXHROpen) {
      window._originalXHROpen = XMLHttpRequest.prototype.open;
      
      XMLHttpRequest.prototype.open = function(method, url, async, user, password) {
        if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
          // Check if it's our request (has _selleasy_custom parameter)
          const isOurRequest = url.indexOf('_selleasy_custom=') !== -1;
          
          if (!isOurRequest && self.isProcessing) {
            let isFromSellEasyWidget = false;
            try {
              const activeElement = document.activeElement;
              if (activeElement) {
                const $activeEl = $(activeElement);
                isFromSellEasyWidget = $activeEl.closest('.selleasy-cart-upsell').length > 0 ||
                                      $activeEl.is('.selleasy-cart-upsell') ||
                                      $activeEl.closest('[class*="lb-button"], [class*="lb-action"]').length > 0;
              }
            } catch (e) {}
            
            if (!isFromSellEasyWidget) {
              try {
                const stack = new Error().stack || '';
                isFromSellEasyWidget = stack.indexOf('selleasy') !== -1 || 
                                      stack.indexOf('lb-button') !== -1 ||
                                      stack.indexOf('lb-action') !== -1 ||
                                      stack.indexOf('installHook') !== -1;
              } catch (e) {}
            }
            
            if (isFromSellEasyWidget) {
              // console.log('SellEasy: Blocked XHR add to cart request from SellEasy widget');
              // Override send to prevent the request
              this._blocked = true;
              const originalSend = this.send;
              this.send = function() {
                if (this._blocked) {
                  this.readyState = 4;
                  this.status = 0;
                  this.statusText = 'Blocked';
                  if (this.onerror) {
                    this.onerror();
                  }
                  return;
                }
                return originalSend.apply(this, arguments);
              };
            }
          }
        }
        
        return window._originalXHROpen.apply(this, arguments);
      };
    }
  },
  
  /**
   * Observe for dynamically loaded SellEasy widgets and reinitialize handlers
   */
  observeSellEasyWidgets: function() {
    // Use MutationObserver to detect when SellEasy widgets are added to DOM
    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(function(mutations) {
        let shouldReinit = false;
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              const $node = $(node);
              // Check if SellEasy widget was added
              if ($node.hasClass('selleasy-cart-upsell') || 
                  $node.find('.selleasy-cart-upsell').length > 0 ||
                  $node.find(SellEasyCart.buttonSelector).length > 0 ||
                  $node.hasClass('lb-action-product') ||
                  $node.find('.lb-action-product').length > 0) {
                shouldReinit = true;
              }
            }
          });
        });
        
        if (shouldReinit) {
          // Remove any SellEasy default handlers that might have been added
          $(SellEasyCart.buttonSelector).off('click');
          $('.selleasy-cart-upsell .lb-action-product, .selleasy-cart-upsell [class*="lb-action"]').off('click');
          $('.selleasy-cart-upsell .lb-action-product *, .selleasy-cart-upsell [class*="lb-action"] *').off('click');
          // Reinitialize our handlers
          SellEasyCart.initAddToCart();
        }
      });
      
      // Start observing
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  },


  initAddToCart: function() {
    // Use the shared button selector
    const buttonSelector = this.buttonSelector;
    
    $(document).off('click.selleasyCart', buttonSelector);
    
    $(buttonSelector).off('click');
    
    $('.selleasy-cart-upsell .lb-action-product, .selleasy-cart-upsell [class*="lb-action"]').off('click');
    
    $('.selleasy-cart-upsell .lb-action-product *, .selleasy-cart-upsell [class*="lb-action"] *').off('click');
    
    if (!window._selleasyCartCaptureHandler) {
      window._selleasyCartCaptureHandler = function(e) {
        const target = e.target;
        const $target = $(target);
        
        const matchedElement = $target.is(buttonSelector) ? $target : $target.closest(buttonSelector);
        
        if (matchedElement.length && matchedElement.closest('.selleasy-cart-upsell').length) {
          e._selleasyHandled = true;
          
          e.stopImmediatePropagation();
          e.preventDefault();
          
          setTimeout(function() {
            matchedElement.trigger('click.selleasyCartCustom');
          }, 0);
        }
      };
      
      document.addEventListener('click', window._selleasyCartCaptureHandler, true);
    }
    
    $(document).on('click.selleasyCartCustom', buttonSelector, function(e) {
      if (e.isDefaultPrevented && e.isDefaultPrevented()) {
        return false;
      }
      
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Prevent multiple simultaneous requests
      if (SellEasyCart.isProcessing) {
        // console.log('SellEasy: Already processing, ignoring click');
        return false;
      }

      const buttonAddSell = $(this);
      
      // Debug logging
      // console.log('SellEasy: Custom handler triggered for element:', buttonAddSell[0]);
      
      // Check if button is already disabled/processing
      if (buttonAddSell.prop('disabled') || buttonAddSell.hasClass('loading')) {
        return false;
      }

      let clickableElement = buttonAddSell;
      if (buttonAddSell.hasClass('lb-action-product') || buttonAddSell.hasClass('lb-action') || buttonAddSell.is('[class*="lb-action"]')) {
        // If it's an action container, find the button inside or use the element itself
        const innerButton = buttonAddSell.find('button, a, [role="button"], .lb-button').first();
        if (innerButton.length) {
          clickableElement = innerButton;
        }
      }

      const cardContainer = clickableElement.closest('.lb-flat-card, .lb-card, .lb-long-card');
      const cardContainerFinal = cardContainer.length ? cardContainer : buttonAddSell.closest('.lb-flat-card, .lb-card, .lb-long-card');
      const imgElm = cardContainerFinal.find('.lb-card-img');

      const productData = SellEasyCart.getProductData(clickableElement, cardContainerFinal, imgElm);

      if (!productData.variantId) {
        const productUrl = productData.productUrl;
        if (productUrl) {
          const handleMatch = productUrl.match(/\/products\/([^\/\?]+)/);
          if (handleMatch && handleMatch[1]) {
            const productHandle = handleMatch[1];
            // Set processing flag
            SellEasyCart.isProcessing = true;
            
            clickableElement.css('opacity', 0.6);
            clickableElement.prop('disabled', true);
            clickableElement.addClass('loading');
            buttonAddSell.css('opacity', 0.6);
            buttonAddSell.addClass('loading');
            
            let iconLoaderFetch = null;
            let buttonTextElementsFetch = null;
            const buttonToShowLoaderFetch = buttonAddSell.hasClass('lb-button-cont') ? buttonAddSell : buttonAddSell.closest('.lb-button-cont');
            if (buttonToShowLoaderFetch.length) {
              // Check if icon-loader already exists
              iconLoaderFetch = buttonToShowLoaderFetch.find('.icon-loader');
              if (iconLoaderFetch.length === 0) {
                // Append icon-loader if it doesn't exist
                iconLoaderFetch = $('<div class="icon-loader"></div>');
                buttonToShowLoaderFetch.append(iconLoaderFetch);
              }
              
              buttonTextElementsFetch = buttonToShowLoaderFetch.children().not('.icon-loader');
              
              buttonTextElementsFetch.each(function() {
                const $el = $(this);
                // Store original display style if not already stored
                if (!$el.data('original-display')) {
                  $el.data('original-display', $el.css('display') || '');
                }
                $el.css('display', 'none');
              });
              
              // Also hide direct text content by wrapping it
              const textNodesFetch = buttonToShowLoaderFetch.contents().filter(function() {
                return this.nodeType === 3 && this.textContent.trim();
              });
              if (textNodesFetch.length > 0) {
                textNodesFetch.each(function() {
                  const $wrapper = $('<span class="selleasy-text-wrapper" style="display: none;"></span>');
                  $(this).replaceWith($wrapper);
                  $wrapper.append(this);
                });
              }
              iconLoaderFetch.show().css('display', 'block');
            }
            
            $(buttonSelector).prop('disabled', true).addClass('loading');
            $('.selleasy-cart-upsell .lb-action-product, .selleasy-cart-upsell [class*="lb-action"]').addClass('loading').css('pointer-events', 'none');
            
            $.getJSON('/products/' + productHandle + '.js', function(product) {
              if (product && product.variants && product.variants.length > 0) {
                let selectedVariant = product.variants.find(v => v.available) || product.variants[0];
                productData.variantId = selectedVariant.id;
                SellEasyCart.processAddToCart(clickableElement, productData, buttonAddSell);
              } else {
                if (iconLoaderFetch && iconLoaderFetch.length) {
                  iconLoaderFetch.hide().css('display', 'none');
                }
                
                if (buttonTextElementsFetch && buttonTextElementsFetch.length) {
                  buttonTextElementsFetch.each(function() {
                    const $el = $(this);
                    const originalDisplay = $el.data('original-display');
                    $el.css('display', originalDisplay || '');
                  });
                }
                
                if (buttonToShowLoaderFetch.length) {
                  buttonToShowLoaderFetch.find('.selleasy-text-wrapper').each(function() {
                    $(this).replaceWith($(this).contents());
                  });
                }
                
                SellEasyCart.isProcessing = false;
                clickableElement.css('opacity', 1);
                clickableElement.prop('disabled', false);
                clickableElement.removeClass('loading');
                buttonAddSell.css('opacity', 1);
                buttonAddSell.removeClass('loading');
                $(buttonSelector).prop('disabled', false).removeClass('loading');
                $('.selleasy-cart-upsell .lb-action-product, .selleasy-cart-upsell [class*="lb-action"]').removeClass('loading').css('pointer-events', '');
                console.error('SellEasy: No variants found for product:', productHandle);
                $('body').addClass('open-message');
                $('.modal-message__error').text('Product variant not found. Please try again.');
              }
            }).fail(function() {
              if (iconLoaderFetch && iconLoaderFetch.length) {
                iconLoaderFetch.hide().css('display', 'none');
              }
              
              if (buttonTextElementsFetch && buttonTextElementsFetch.length) {
                buttonTextElementsFetch.each(function() {
                  if (this.nodeType === 1) {
                    $(this).css('display', '');
                  } else if (this.nodeType === 3) {
                    const $parent = $(this).parent();
                    if ($parent.is('span[style*="display: none"]')) {
                      $parent.replaceWith(this);
                    }
                  }
                });
              }
              
              SellEasyCart.isProcessing = false;
              clickableElement.css('opacity', 1);
              clickableElement.prop('disabled', false);
              clickableElement.removeClass('loading');
              buttonAddSell.css('opacity', 1);
              buttonAddSell.removeClass('loading');
              $(buttonSelector).prop('disabled', false).removeClass('loading');
              $('.selleasy-cart-upsell .lb-action-product, .selleasy-cart-upsell [class*="lb-action"]').removeClass('loading').css('pointer-events', '');
              console.error('SellEasy: Failed to fetch product data');
              $('body').addClass('open-message');
              $('.modal-message__error').text('Unable to add product to cart. Please try again.');
            });
            return;
          }
        }
        
        console.error('SellEasy: Variant ID not found and cannot determine product handle');
        $('body').addClass('open-message');
        $('.modal-message__error').text('Product variant not found. Please try again.');
        return;
      }
      
      SellEasyCart.processAddToCart(clickableElement, productData, buttonAddSell);
      
      return false; // Prevent any default behavior and other handlers
    });
    
    // Also prevent SellEasy's default form submission if button is inside a form
    $(document).off('submit.selleasyCart', '.selleasy-cart-upsell form');
    $(document).on('submit.selleasyCart', '.selleasy-cart-upsell form', function(e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
  },

  processAddToCart: function(clickableElement, productData, originalElement) {
    const uiElement = originalElement || clickableElement;
    
    SellEasyCart.isProcessing = true;
    
    const originalText = uiElement.text() || uiElement.find('span').text() || 'Add to cart';
    const originalHtml = uiElement.html();
    clickableElement.css('opacity', 0.6);
    clickableElement.prop('disabled', true);
    clickableElement.addClass('loading');
    uiElement.css('opacity', 0.6);
    uiElement.addClass('loading');
    
    let iconLoader = null;
    let buttonTextElements = null;
    const buttonToShowLoader = uiElement.hasClass('lb-button') ? uiElement : uiElement.closest('.lb-button-cont');
    if (buttonToShowLoader.length) {
      // Check if icon-loader already exists
      iconLoader = buttonToShowLoader.find('.icon-loader');
      if (iconLoader.length === 0) {
        // Append icon-loader if it doesn't exist
        iconLoader = $('<div class="icon-loader"></div>');
        buttonToShowLoader.append(iconLoader);
      }
      
      buttonTextElements = buttonToShowLoader.children().not('.icon-loader');
      
      buttonTextElements.each(function() {
        const $el = $(this);
        if (!$el.data('original-display')) {
          $el.data('original-display', $el.css('display') || '');
        }
        $el.css('display', 'none');
      });
      
      const textNodes = buttonToShowLoader.contents().filter(function() {
        return this.nodeType === 3 && this.textContent.trim();
      });
      if (textNodes.length > 0) {
        textNodes.each(function() {
          const $wrapper = $('<span class="selleasy-text-wrapper" style="display: none;"></span>');
          $(this).replaceWith($wrapper);
          $wrapper.append(this);
        });
      }
      
      iconLoader.show().css('display', 'block');
    }
    
    $(SellEasyCart.buttonSelector).prop('disabled', true).addClass('loading');
    $('.selleasy-cart-upsell .lb-action-product, .selleasy-cart-upsell [class*="lb-action"]').addClass('loading').css('pointer-events', 'none');

    SellEasyCart.addToCart(productData)
      .done(function(response) {
        if (iconLoader && iconLoader.length) {
          iconLoader.hide().css('display', 'none');
        }
        
        if (buttonTextElements && buttonTextElements.length) {
          buttonTextElements.each(function() {
            const $el = $(this);
            const originalDisplay = $el.data('original-display');
            $el.css('display', originalDisplay || '');
          });
        }
        
        if (buttonToShowLoader.length) {
          buttonToShowLoader.find('.selleasy-text-wrapper').each(function() {
            $(this).replaceWith($(this).contents());
          });
        }
        
        clickableElement.css('opacity', 1).removeClass('loading');
        uiElement.css('opacity', 1).removeClass('loading');
        
        uiElement.html('<span>Added!</span>');
        SellEasyCart.updateMinicart(productData, response);

        $(document).trigger('selleasy:added-to-cart', {
          product: productData,
          response: response
        });

        setTimeout(() => {
          SellEasyCart.isProcessing = false;
          clickableElement.prop('disabled', false);
          clickableElement.removeClass('loading');
          uiElement.html(originalHtml);
          uiElement.removeClass('loading');

          $(SellEasyCart.buttonSelector).prop('disabled', false).removeClass('loading');
          $('.selleasy-cart-upsell .lb-action-product, .selleasy-cart-upsell [class*="lb-action"]').removeClass('loading').css('pointer-events', '');
        }, 2000);

      })
      .fail(function(xhr) {
        if (iconLoader && iconLoader.length) {
          iconLoader.hide().css('display', 'none');
        }
        
        const buttonToShowLoaderError = uiElement.hasClass('lb-button') ? uiElement : uiElement.closest('.lb-button-cont');
        if (buttonTextElements && buttonTextElements.length && buttonToShowLoaderError.length) {
          buttonTextElements.each(function() {
            const $el = $(this);
            const originalDisplay = $el.data('original-display');
            $el.css('display', originalDisplay || '');
          });
        }
        
        if (buttonToShowLoaderError.length) {
          buttonToShowLoaderError.find('.selleasy-text-wrapper').each(function() {
            $(this).replaceWith($(this).contents());
          });
        }
        
        SellEasyCart.isProcessing = false;
        
        clickableElement.css('opacity', 1).removeClass('loading');
        clickableElement.prop('disabled', false);
        uiElement.css('opacity', 1).removeClass('loading');
        
        $(SellEasyCart.buttonSelector).prop('disabled', false).removeClass('loading');
        $('.selleasy-cart-upsell .lb-action-product, .selleasy-cart-upsell [class*="lb-action"]').removeClass('loading').css('pointer-events', '');
        
        let errorMessage = 'Unable to add product to cart. Please try again.';
        try {
          const errorResponse = $.parseJSON(xhr.responseText);
          if (errorResponse && errorResponse.description) {
            errorMessage = errorResponse.description;
          }
        } catch (e) {
          console.error('SellEasy: Error parsing response', e);
        }

        $('body').addClass('open-message');
        $('.modal-message__error').text(errorMessage);

        $(document).trigger('selleasy:add-to-cart-error', {
          product: productData,
          error: errorMessage
        });
      });
  },

  
  getProductData: function(buttonAddSell, parentVariant, imgElm) {
    const card = buttonAddSell.closest('.lb-card, .lb-long-card, .lb-flat-card');
    
    // Try multiple ways to get variant ID
    let variantId = null;
    
    variantId = parentVariant.attr('lb-variant-id') || 
                card.attr('lb-variant-id') || 
                card.attr('data-variant-id') ||
                card.data('variant-id') ||
                buttonAddSell.attr('data-variant-id') ||
                buttonAddSell.data('variant-id') ||
                buttonAddSell.attr('lb-variant-id') || 
                buttonAddSell.data('lb-variant-id');
    
    if (!variantId) {
      const hiddenInput = card.find('input[type="hidden"][name="id"], input[type="hidden"][data-variant-id]');
      if (hiddenInput.length) {
        variantId = hiddenInput.val() || hiddenInput.attr('value') || hiddenInput.data('variant-id');
      }
    }
    
    if (!variantId) {
      const selectElement = card.find('select[name="id"], select[data-variant-id]');
      if (selectElement.length) {
        variantId = selectElement.val();
      }
    }
    
    if (!variantId) {
      const variantElement = card.find('[data-variant-id]').first();
      if (variantElement.length) {
        variantId = variantElement.attr('data-variant-id') || 
                   variantElement.data('variant-id') ||
                   variantElement.val();
      }
    }
    
    if (!variantId) {
      const form = buttonAddSell.closest('form');
      if (form.length) {
        const formInput = form.find('input[name="id"], input[type="hidden"][value]');
        if (formInput.length) {
          variantId = formInput.val() || formInput.attr('value');
        }
      }
    }
    
    if (!variantId && card.length) {
      const cardData = card.data();
      if (cardData && cardData.variantId) {
        variantId = cardData.variantId;
      } else if (cardData && cardData.variant) {
        variantId = cardData.variant;
      }
    }
    
    if (!variantId) {
      const variantContainer = buttonAddSell.closest('[data-variant], [data-variant-id], [lb-variant-id]');
      if (variantContainer.length) {
        variantId = variantContainer.attr('data-variant-id') ||
                   variantContainer.data('variant-id') ||
                   variantContainer.attr('data-variant') ||
                   variantContainer.data('variant') ||
                   variantContainer.attr('lb-variant-id');
      }
    }
    
    return {
      variantId: variantId,
      quantity: parseInt(buttonAddSell.attr('data-quantity')) || parseInt(buttonAddSell.data('quantity')) || 1,
      productTitle: card.find('.lb-card-title').text().trim(),
      productImage: imgElm.length ? imgElm.attr('src') : card.find('.lb-card-img').attr('src'),
      productPrice: card.find('.lb-price, .lb-price-sale-price').text().trim(),
      productUrl: card.find('.lb-card-title').attr('href') || card.find('a').first().attr('href'),
      properties: SellEasyCart.extractProperties(card)
    };
  },


  extractProperties: function(card) {
    const properties = {};

    const variantPicker = card.find('.lb-variant-picker');
    if (variantPicker.length) {
      properties.variant = variantPicker.text().trim();
    }

    card.find('[data-property]').each(function() {
      const prop = $(this);
      properties[prop.attr('data-property')] = prop.text().trim();
    });

    return properties;
  },

  addToCart: function(productData) {
    // Mark this as our request with unique identifier
    const requestId = 'selleasy_custom_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    
    const data = {
      id: productData.variantId,
      quantity: productData.quantity
    };

    // Add properties if any
    if (Object.keys(productData.properties).length > 0) {
      data.properties = productData.properties;
    }

    // Add our custom marker to identify this request
    const url = '/cart/add.js?_=' + Date.now() + '&_selleasy_custom=' + requestId;
    
    // console.log('SellEasy: Adding to cart - Variant ID:', productData.variantId, 'Request ID:', requestId);

    return $.ajax({
      type: 'POST',
      url: url,
      data: data,
      dataType: 'json',
      cache: false,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'If-Modified-Since': 'Thu, 01 Jan 1970 00:00:00 GMT',
        'X-SellEasy-Custom': 'true' // Custom header to identify our requests
      }
    });
  },

  updateMinicart: function(productData, cartResponse) {
    // Get current cart data
    $.getJSON('/cart.js', function(cartData) {
      try {
        // Update cart count and total
        $('[data-cart-count]').text('(' + cartData.item_count + ')');
        $('[data-total-count]').text(cartData.item_count);
        $('[data-cart-total]').text(Shopify.formatMoney(cartData.total_price, theme.moneyFormat));

        // Safely rebuild cart items
        const cartItems = cartData.items;
        const cartContainer = $('.js-cart');
        
        if (cartContainer.length && cartItems.length > 0) {
          // Build all cart items HTML
          const cartItemsHTML = cartItems.map(function(item) {
            CartDrawer.addProgressBar(item);
            return CartDrawer.buildCartItemList(item);
          }).join('');

          // Safely update cart content
          if (cartItemsHTML) {
            cartContainer.html(cartItemsHTML);
          }

          // Show minicart
          $('body').addClass('open-cart');
          $('.cart-popup__container').show();
          $('.cart-popup__empty').hide();

          // Reinitialize cart functionality
          CartDrawer.initUpdateCart();
          CartDrawer.initQuantity();
          CartDrawer.initRemoveCart();
        } else if (cartItems.length === 0) {
          // Handle empty cart
          cartContainer.empty();
          $('.cart-popup__container').hide();
          $('.cart-popup__empty').show();
        }
      } catch (error) {
        console.error('SellEasy: Error updating cart display:', error);
        // Fallback: refresh entire cart
        CartDrawer.getData();
      }
    }).fail(function(xhr) {
      console.error('SellEasy: Failed to get cart data:', xhr);
      // Fallback: refresh entire cart
      CartDrawer.getData();
    });
  }
};

